import { Stack, Typography } from '@mui/material';
import React, { memo, useState } from 'react';
import styled from 'styled-components';
import { Avatar, AvatarGroup, IPersonAvatarProps } from '../../AvatarGroup';

const StyledUserCard = styled.div`
`;

const Counter = styled.span`
  color: #64748b;
  font-size: 0.85rem;
`;

const ImageContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f6f7f9;
  padding: 0.025rem;
  margin-left: -0.5rem;
`;

const StudentContainer = styled(Stack)`
  flex-direction: row !important;
  align-items: center;
  gap: 1rem;
`;

const BottomLine = styled.div`
  width: calc(100% - 0.5rem);
  margin: 0.5rem auto;
  background: #d5d9e2;
  height: 1px;
`;

interface IProps {
  title: string;
  data: IPersonAvatarProps[];
  defaultViewType?: 'avatar' | 'list';
  allowViewTypeSwitching?: boolean;
}

export const PersonAvatarLists = memo(({ title, data, defaultViewType = 'avatar', allowViewTypeSwitching = true }: IProps) => {
  const MAX_PERSONS = 5;
  const showCountImg = data.length > MAX_PERSONS;
  const [viewType, setViewType] = useState<'avatar' | 'list'>(defaultViewType);

  return (
    <StyledUserCard>
      <Typography fontWeight={'700'} marginTop={0.75}>
        {title} <Counter>({data.length})</Counter>
      </Typography>
      {viewType === 'avatar' && (
        <Stack flexDirection={'row'} marginTop={0.75}>
          <AvatarGroup max={MAX_PERSONS} data={data}></AvatarGroup>

          {showCountImg && (
            <ImageContainer
              onClick={() => {
                setViewType('list');
              }}
            >
              <Stack
                alignItems={'center'}
                justifyContent={'center'}
                sx={{
                  background: '#ECEEF2',
                  borderRadius: '50%',
                  height: 'calc(100% - 5px)',
                  width: 'calc(100% - 5px)',
                  transform: 'translate(2px, 2px)',
                  padding: '0.0175rem',
                }}
              >
                <Typography fontWeight={'700'}>
                  <Counter> +{data.length - MAX_PERSONS}</Counter>
                </Typography>
              </Stack>
            </ImageContainer>
          )}
        </Stack>
      )}

      {viewType === 'list' && (
        <Stack marginTop={1}>
          {data.map((user, index) => {
            return (
              <React.Fragment key={index}>
                <StudentContainer>
                  <Avatar src={user.avatar} gender={user.gender} />
                  <Stack>
                    <Typography fontWeight={'700'} fontSize={'0.875rem'}>
                      {user.name ?? user.username}
                    </Typography>
                    {user.role && (
                      <Typography fontSize={'0.75rem'} color='#64748B'>
                        {user.role}
                      </Typography>
                    )}
                  </Stack>
                </StudentContainer>
                {index < data.length - 1 && <BottomLine />}
              </React.Fragment>
            );
          })}
        </Stack>
      )}
    </StyledUserCard>
  );
});
